<template lang="pug">
  div.page--cart.page
    checkout-page-header.page-header--account(
      :step="1"
      header-class="page-header--checkout-step"
      header-background="/img/frontend/page/page-header-default-background.jpg"
    )
    .container.my-5
      .row
        .col-lg-7
          .checkout-shipping
            h3.checkout-shipping__title {{ trans('labels.frontend.account.profile.personal-details') }}
            .row
              .col-lg-6.col-12
                .form-group.form-group--required(
                  v-bind:class="{'form-group--valid' : !$v.form.first_name.$invalid, 'form-group--error' : $v.form.first_name.$invalid }"
                )
                  label.control-label(for='first_name') {{ trans('labels.frontend.user.profile.first_name') }}
                  input.form-control(type='text', name='first_name', maxlength='199', :placeholder="trans('labels.frontend.user.profile.first_name')" v-model.trim="$v.form.first_name.$model")
                  font-awesome-icon.form-group__status-icon(:icon=['far', 'check'])
              .col-lg-6.col-12
                .form-group.form-group--required(
                  v-bind:class="{'form-group--valid' : !$v.form.last_name.$invalid, 'form-group--error' : $v.form.last_name.$invalid }"
                )
                  label.control-label(for='last_name') {{ trans('labels.frontend.user.profile.last_name') }}
                  input.form-control(type='text', name='last_name', maxlength='199', :placeholder="trans('labels.frontend.user.profile.last_name')" v-model.trim="$v.form.last_name.$model")
                  font-awesome-icon.form-group__status-icon(:icon=['far', 'check'])
            .row
              .col-lg-6.col-12
                .form-group.form-group--required(
                  v-bind:class="{'form-group--valid' : !$v.form.email.$invalid, 'form-group--error' : $v.form.email.$invalid }"
                )
                  label.control-label(for='email') {{ trans('labels.frontend.user.profile.email') }}
                  input.form-control(type='email', name='email', maxlength='199', :placeholder="trans('labels.frontend.user.profile.email')" v-model.trim="$v.form.email.$model")
                  font-awesome-icon.form-group__status-icon(:icon=['far', 'check'])
              .col-lg-6.col-12
                .form-group.form-group--required(
                  v-bind:class="{'form-group--valid' : !$v.form.tel.$invalid, 'form-group--error' : $v.form.tel.$invalid }"
                )
                  label.control-label(for='tel') {{ trans('labels.frontend.user.profile.tel') }}
                  input.form-control(type='tel', name='tel', maxlength='199', :placeholder="trans('labels.frontend.user.profile.tel')" v-model="$v.form.tel.$model")
                  font-awesome-icon.form-group__status-icon(:icon=['far', 'check'])
            h3.checkout-shipping__title.mt-4 {{ trans('labels.frontend.account.profile.shipping-address') }}
            div(v-if="$store.getters['auth/isLoggedIn']")
              .row
                .col-12
                  shipping-address-box(
                    :selectable="true"
                    :selected="typeof form.shipping_address !== 'undefined' && form.shipping_address.id === address.id"
                    :address="address"
                    v-if="user.shipping_addresses"
                    v-for="address in user.shipping_addresses"
                    :key="address.id"
                    @deleted="getUser"
                    @updated="getUser"
                    @clicked="onShippingAddressClicked"
                  )
                  create-address-button(type="shipping" @created="getUser")
            div(v-if="!$store.getters['auth/isLoggedIn']")
              .row
                .col-6
                  .form-group.form-group--required
                    label.control-label(for='shipping_first_name') ชื่อ
                    input.form-control(type='text', name='shipping_first_name', maxlength='199', placeholder='ชื่อ')
                .col-6
                  .form-group.form-group--required
                    label.control-label(for='shipping_last_name') นามสกุล
                    input.form-control(type='text', name='shipping_last_name', maxlength='199', placeholder='นามสกุล')
              .row
                .col
                  .form-group.form-group--required
                    label.control-label(for='shipping_tel') เบอร์โทร
                    input.form-control(type='text', name='shipping_tel', maxlength='199', placeholder='เบอร์โทร')
              .row
                .col
                  .form-group.form-group--required
                    label.control-label(for='shipping_address') ที่อยู่
                    input.form-control(type='text', name='shipping_address', maxlength='199', placeholder='ที่อยู่')
              .row
                .col-6
                  .form-group.form-group--required
                    label.control-label(for='shipping_postal_code') รหัสไปรษณีย์
                    input.form-control(type='number', name='shipping_postal_code', step='1', max='99999', min='10000', placeholder='รหัสไปรษณีย์')
                .col-6
                  .form-group.form-group--required
                    label.control-label(for='shipping_district') อำเภอ/เขต
                    select#shipping_district_select.custom-select(name='shipping_district')
                      option เลือกอำเภอ/เขต
              .row
                .col-6
                  .form-group.form-group--required
                    label.control-label(for='shipping_sub_district') ตำบลแชวง
                    select#shipping_district_select.custom-select(name='shipping_sub_district')
                      option เลือกตำบลแชวง
                .col-6
                  .form-group.form-group--required
                    label.control-label(for='shipping_province') จังหวัด
                    select#shipping_district_select.custom-select(name='shipping_province')
                      option เลือกจังหวัด
            h3.checkout-shipping__title.mt-4
              | {{ trans('labels.frontend.checkout.tax_invoice') }}
              .checkbox.switch.d-inline-block.ml-2
                label
                  input.switch-control(type='checkbox' v-model="form.tax_invoice")
                  .switch-label.switch-label--en
                    span {{ trans('labels.frontend.checkout.tax_invoice_needed') }}
            div(v-if="$store.getters['auth/isLoggedIn'] && form.tax_invoice")
              .row
                .col-12
                  billing-address-box(
                    :selectable="true"
                    :selected="typeof form.billing_address !== 'undefined' && form.billing_address.id === address.id"
                    :address="address"
                    v-if="user.billing_addresses"
                    v-for="address in user.billing_addresses"
                    :key="address.id"
                    @deleted="getUser"
                    @updated="getUser"
                    @clicked="onBillingAddressClicked"
                  )
                  create-address-button(type="billing" @created="getUser")
            div(v-if="!$store.getters['auth/isLoggedIn']")
              .row
                .col
                  .form-group.form-group--required
                    label.control-label(for='billing_company_name') ชื่อบริษัท
                    input.form-control(type='text', name='billing_company_name', maxlength='199', placeholder='ชื่อบริษัท')
              .row
                .col-6
                  .form-group.form-group--required
                    label.control-label(for='billing_company_tax_no') เลขประจำตัวผู้เสียภาษี 13 หลัก
                    input.form-control(type='text', name='billing_company_tax_no', maxlength='13', placeholder='เลขประจำตัวผู้เสียภาษี 13 หลัก')
                .col-6
                  label.control-label(for='billing_company_tax_no')
              .row
                .col
                  .form-group.form-group--required
                    label.control-label(for='shipping_address') ที่อยู่
                    input.form-control(type='text', name='shipping_address', maxlength='199', placeholder='ที่อยู่')
              .row
                .col-6
                  .form-group.form-group--required
                    label.control-label(for='shipping_postal_code') รหัสไปรษณีย์
                    input.form-control(type='number', name='shipping_postal_code', step='1', max='99999', min='10000', placeholder='รหัสไปรษณีย์')
                .col-6
                  .form-group.form-group--required
                    label.control-label(for='shipping_district') อำเภอ/เขต
                    select#shipping_district_select.custom-select(name='shipping_district')
                      option เลือกอำเภอ/เขต
              .row
              .col-6
                .form-group.form-group--required
                  label.control-label(for='shipping_sub_district') ตำบลแชวง
                  select#shipping_district_select.custom-select(name='shipping_sub_district')
                    option เลือกตำบลแชวง
              .col-6
                .form-group.form-group--required
                  label.control-label(for='shipping_province') จังหวัด
                  select#shipping_district_select.custom-select(name='shipping_province')
                    option เลือกจังหวัด
            h3.checkout-shipping__title.mt-4.d-none วิธีการจัดส่ง
            .row.d-none
              .col-lg-6
                .custom-radio.custom-radio--shipping
                  input#custom-radio(type='radio', name='custom-radio', value='1')
                  .custom-radio__content
                    label.custom-radio__label(for='custom-radio')
                      img.custom-radio__image(src='/img/frontend/logo/shipping/thailand-post.png', alt='')
                      span.custom-radio__title ไปรษณีย์ไทย
                      span.custom-radio__meta ฟรี
              .col-lg-6
                .custom-radio.custom-radio--shipping
                  input#custom-radio-2(type='radio', name='custom-radio', value='2')
                  .custom-radio__content
                    label.custom-radio__label(for='custom-radio-2')
                      img.custom-radio__image(src='/img/frontend/logo/shipping/kerry-express.png', alt='')
                      span.custom-radio__title Kerry Express
                      span.custom-radio__meta + ฿15
              .col-lg-6
                .custom-radio.custom-radio--shipping
                  input#custom-radio-3(type='radio', name='custom-radio', value='3')
                  .custom-radio__content
                    label.custom-radio__label(for='custom-radio-3')
                      img.custom-radio__image(src='/img/frontend/logo/shipping/fedex.png', alt='')
                      span.custom-radio__title FedEx
                      span.custom-radio__meta + ฿20
        .col-lg-4.offset-lg-1
          .cart-summary
            .cart-summary__body
              table.table.cart-summary__table
                tbody
                  tr
                    td {{ trans('labels.frontend.cart.table.sub_total_vat_incl') }}
                    td.text-right ฿ {{ $store.getters['cart/totals'] | numeral }}
                  tr(v-if="$store.getters['cart/coupon'] && $store.getters['cart/coupon'].id")
                    td {{ trans('labels.frontend.cart.table.discount') }} ({{ $store.getters['cart/coupon'].code }})
                    td.text-right
                      strong.text-primary - ฿ {{ $store.getters['cart/total_discount'] | numeral }}
                  tr
                    td {{ trans('labels.frontend.cart.table.shipping_fees') }}
                    td.text-right ฿ {{ $store.getters['cart/shipping_cost'] | numeral }}
                  tr
                    td
                      strong {{ trans('labels.frontend.cart.table.net_total') }}
                    td.text-right ฿ {{ $store.getters['cart/net_total'] | numeral }}
            .cart-summary__body
              router-link.btn.btn-primary.btn-block.btn-lg(:to="{ name: 'payment' }" :disabled="$v.$invalid") {{ trans('labels.frontend.checkout.place_order') }}
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, requiredIf, email } from 'vuelidate/lib/validators';
import CreateAddressButton from '../../../components/account/CreateAddressButton.vue';
import BillingAddressBox from '../../../components/account/BillingAddressBox.vue';
import ShippingAddressBox from '../../../components/account/ShippingAddressBox.vue';
import CheckoutPageHeader from '../../../components/layouts/CheckoutPageHeader.vue';
import notify from '../../../components/notify';
// import cart from '../../../store/modules/cart';

const form = {
  first_name: '',
  last_name: '',
  email: '',
  tel: '',
};

export default {
  components: {
    CheckoutPageHeader,
    CreateAddressButton,
    BillingAddressBox,
    ShippingAddressBox,
  },
  mixins: [validationMixin],
  metaInfo() {
    return {
      title: Lang.get('labels.frontend.cart.steps.shipping-details'),
    };
  },
  data() {
    return {
      cart: {},
      form,
      user: {},
    };
  },
  mounted() {
    this.getCart();
    this.getUser();

    if (this.$store.getters['auth/isLoggedIn']) {
      const user = this.$store.getters['auth/user'];
      const cartUser = this.$store.getters['cart/user'];
      console.log(user);
      this.user = user;
      this.form = {
        ...this.form,
        ...{
          id: user.id,
          first_name: user.first_name,
          last_name: user.last_name,
          email: user.email,
          tel: user.tel,
          billing_address: {},
          shipping_address: {},
        },
      };

      this.$store.dispatch('cart/update_user', { id: this.$store.getters['cart/id'], type: 'user', user });
      this.getCart();

      this.$ga.ecommerce.setAction('checkout', {
        step: 2,
      });
    }

    this.$watch('form', async (user) => {
      await this.$store.dispatch('cart/update_user', { id: this.$store.getters['cart/id'], type: 'user', user });
      await this.getCart();
    }, { deep: true });

    this.$watch('form.tax_invoice', (val, oldVal) => {
      if (val === oldVal) return;
      if (!val) {
        this.form = { ...this.form, ...{ billing_address: false } };
      }
    });
  },
  validations: {
    form: {
      first_name: { required },
      last_name: { required },
      email: { required, email },
      tel: { required },
      shipping_address: { required },
      billing_address: {
        required: requiredIf(function () {
          return this.form.tax_invoice === true;
        }),
      },
    },
  },
  methods: {
    async getCart() {
      try {
        const { data } = await this.$store.dispatch('cart/get', { id: this.$store.getters['cart/id'] });
        this.cart = data;
      } catch (e) {
        this.cart = {};
      }
    },
    async getUser() {
      try {
        await this.$store.dispatch('account/get', { with: 'shipping_addresses|billing_addresses' }).then((resp) => {
          this.user = resp.data;
        });
      } catch (e) {
        notify.errors(this, e);
      }
    },
    async onShippingAddressClicked(address) {
      this.form = { ...this.form, ...{ shipping_address: address } };
    },
    async onBillingAddressClicked(address) {
      this.form = { ...this.form, ...{ billing_address: address } };
    },
  },
};
</script>
